//@flow
import { red } from '@material-ui/core/colors'
import { createTheme } from '@material-ui/core/styles'

const theme: any = createTheme({
    palette: {
      primary: {
        main: '#D4AF37', // Premium Gold
        light: '#F3C817',
        dark: '#AA8C2C',
        contrastText: '#fff',
      },
      secondary: {
        main: '#1A2027', // Deep Charcoal
        light: '#2C3E50',
        dark: '#000000',
        contrastText: '#fff',
      },
      error: {
        main: red.A400,
      },
      background: {
        default: '#F4F6F8', // Light Gray background for depth
        paper: '#ffffff',
      },
      text: {
        primary: '#1A2027',
        secondary: '#5E6C84',
      }
    },
    typography: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      button: {
        textTransform: 'none', // Modern feel
        fontWeight: 600,
      },
    },
    shape: {
      borderRadius: 8, // Softer corners
    },
    shadows: [
      'none',
      '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.1)',
      '0 2px 6px rgba(0,0,0,0.06), 0 2px 4px rgba(0,0,0,0.12)',
      '0 4px 12px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.14)',
      '0 6px 20px rgba(0,0,0,0.1), 0 4px 10px rgba(0,0,0,0.16)',
      '0 8px 30px rgba(0,0,0,0.12), 0 6px 15px rgba(0,0,0,0.18)',
      '0 10px 40px rgba(0,0,0,0.14), 0 8px 20px rgba(0,0,0,0.2)',
      '0 12px 50px rgba(0,0,0,0.16), 0 10px 25px rgba(0,0,0,0.22)',
      '0 14px 60px rgba(0,0,0,0.18), 0 12px 30px rgba(0,0,0,0.24)',
      '0 16px 70px rgba(0,0,0,0.2), 0 14px 35px rgba(0,0,0,0.26)',
      '0 18px 80px rgba(0,0,0,0.22), 0 16px 40px rgba(0,0,0,0.28)',
      '0 20px 90px rgba(0,0,0,0.24), 0 18px 45px rgba(0,0,0,0.3)',
      '0 22px 100px rgba(0,0,0,0.26), 0 20px 50px rgba(0,0,0,0.32)',
      '0 24px 110px rgba(0,0,0,0.28), 0 22px 55px rgba(0,0,0,0.34)',
      '0 26px 120px rgba(0,0,0,0.3), 0 24px 60px rgba(0,0,0,0.36)',
      '0 28px 130px rgba(0,0,0,0.32), 0 26px 65px rgba(0,0,0,0.38)',
      '0 30px 140px rgba(0,0,0,0.34), 0 28px 70px rgba(0,0,0,0.4)',
      '0 32px 150px rgba(0,0,0,0.36), 0 30px 75px rgba(0,0,0,0.42)',
      '0 34px 160px rgba(0,0,0,0.38), 0 32px 80px rgba(0,0,0,0.44)',
      '0 36px 170px rgba(0,0,0,0.4), 0 34px 85px rgba(0,0,0,0.46)',
      '0 38px 180px rgba(0,0,0,0.42), 0 36px 90px rgba(0,0,0,0.48)',
      '0 40px 190px rgba(0,0,0,0.44), 0 38px 95px rgba(0,0,0,0.5)',
      '0 42px 200px rgba(0,0,0,0.46), 0 40px 100px rgba(0,0,0,0.52)',
      '0 44px 210px rgba(0,0,0,0.48), 0 42px 105px rgba(0,0,0,0.54)',
      '0 46px 220px rgba(0,0,0,0.5), 0 44px 110px rgba(0,0,0,0.56)',
    ],
    overrides: {
      MuiButton: {
        root: {
          borderRadius: 8,
          boxShadow: 'none',
          padding: '8px 20px',
          fontSize: '0.875rem',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
        containedPrimary: {
          color: '#fff',
          background: 'linear-gradient(135deg, #D4AF37 0%, #F3C817 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #F3C817 0%, #D4AF37 100%)',
          },
        }
      },
      MuiPaper: {
        elevation1: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.1)',
        },
        rounded: {
          borderRadius: 12,
        }
      },
      MuiAppBar: {
        root: {
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        }
      },
      MuiDrawer: {
        paper: {
          backgroundColor: '#ffffff',
          borderRight: '1px solid rgba(0,0,0,0.05)',
        }
      },
      MuiChip: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
        colorPrimary: {
          background: 'linear-gradient(135deg, #D4AF37 0%, #F3C817 100%)',
          color: '#fff',
        }
      },
      MuiTableCell: {
        root: {
          borderBottom: '1px solid #f1f5f9',
        },
        head: {
          fontWeight: 600,
          color: '#475569',
          textTransform: 'uppercase',
          fontSize: '0.75rem',
          letterSpacing: '0.05em',
          background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
          borderBottom: '2px solid #e2e8f0',
        }
      }
    }
  });
  
  export default theme

